import { render } from "./FamilyLandingPage.vue?vue&type=template&id=6314e9fc&scoped=true"
const script = {}

import "./FamilyLandingPage.vue?vue&type=style&index=0&id=6314e9fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6314e9fc"]])

export default __exports__